export default "__VITE_ASSET__K5P_mIxA__"